
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a5bb2408&scoped=true!./Username.css")

var Component = require("/quotes-front/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Username.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-a5bb2408!./../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./Username.pug"),
  /* scopeId */
  "data-v-a5bb2408",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Username/Username.vue
// module id = 255
// module chunks = 2